import styled from "@emotion/styled";

export default styled.div`
  padding-top: 72px;
  min-height: 50vh;
`;